exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timelineitem[data-v-63e2d5c0]{margin-bottom:-8px}.el-timeline-item[data-v-63e2d5c0]{padding-bottom:8px !important}", ""]);

// exports
